/* TMC — Secret mode (Konami). window.hwSecret = {on, code, label, note}.
   Desktop: ↑↑↓↓←→←→ B A. Mobile: hold the logo ~1s, or tap it 5 times fast.
   Fires a `tmc:secret` event so the promo layer can reprice. */
(function(){
  var cfg=window.hwSecret||{};if(!cfg.on)return;
  var H=document.documentElement,KEY='hw_secret_on',
      SEQ=['ArrowUp','ArrowUp','ArrowDown','ArrowDown','ArrowLeft','ArrowRight','ArrowLeft','ArrowRight','b','a'],
      idx=0,card=null;

  function persisted(){try{return localStorage.getItem(KEY)==='1'}catch(e){return false}}
  function persist(v){try{v?localStorage.setItem(KEY,'1'):localStorage.removeItem(KEY)}catch(e){}}
  function isOn(){return H.classList.contains('hw-secret-on')}
  function logoEl(){return document.querySelector('.header__heading-link')||document.querySelector('.header__heading a')||document.querySelector('.header__heading')}
  function fire(){try{document.dispatchEvent(new CustomEvent('tmc:secret',{detail:{on:isOn()}}))}catch(e){}}

  function buildCard(){
    if(card&&document.body.contains(card))return;
    card=document.createElement('div');card.className='hw-secret';card.setAttribute('role','status');
    var txt=document.createElement('div');
    txt.innerHTML='<b>'+(cfg.label||'Secret mode unlocked')+'</b><span>'+(cfg.note||'')+'</span>';
    if(cfg.code){
      var co=document.createElement('code');co.textContent=cfg.code;co.title='Tap to copy';
      co.addEventListener('click',function(){
        try{navigator.clipboard.writeText(cfg.code)}catch(e){}
        var old=co.textContent;co.textContent='Copied';co.classList.add('copied');
        setTimeout(function(){co.textContent=old;co.classList.remove('copied')},1400);
      });
      txt.appendChild(co);
      var ap=document.createElement('a');ap.className='apply';ap.textContent='Apply now';
      ap.href='/discount/'+encodeURIComponent(cfg.code)+'?redirect=/cart';
      txt.appendChild(ap);
    }
    var x=document.createElement('button');x.className='x';x.type='button';x.setAttribute('aria-label','Exit secret mode');x.textContent='\u00d7';
    x.addEventListener('click',function(){off()});
    card.appendChild(txt);card.appendChild(x);
    document.body.appendChild(card);
  }
  function flash(){var f=document.createElement('div');f.className='hw-secret-flash';document.body.appendChild(f);setTimeout(function(){f.remove()},700)}
  function buzz(){try{if(navigator.vibrate)navigator.vibrate([12,40,18])}catch(e){}}

  function on(a){H.classList.add('hw-secret-on');persist(true);if(a){flash();buzz()}buildCard();fire()}
  function off(){H.classList.remove('hw-secret-on');persist(false);if(card){card.remove();card=null}fire()}
  function toggle(){isOn()?off():on(true)}

  function mark(){var l=logoEl();if(l&&!l.dataset.hwSecret){l.dataset.hwSecret='1';l.style.webkitTouchCallout='none';l.style.webkitUserSelect='none';l.style.userSelect='none'}}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',mark)}else{mark()}
  document.addEventListener('shopify:section:load',function(){setTimeout(mark,60)});

  var holdTimer=null,heldFired=false,taps=0,lastTap=0,tapTimer=null;
  function inLogo(t){return t&&t.closest&&t.closest('.header__heading')}
  function cancelHold(){if(holdTimer){clearTimeout(holdTimer);holdTimer=null}}

  document.addEventListener('touchstart',function(e){
    if(!inLogo(e.target))return;
    heldFired=false;cancelHold();
    holdTimer=setTimeout(function(){heldFired=true;toggle()},1000);
  },true);
  document.addEventListener('touchmove',function(e){if(inLogo(e.target))cancelHold()},true);
  document.addEventListener('touchend',function(e){if(inLogo(e.target))cancelHold()},true);
  document.addEventListener('touchcancel',function(e){if(inLogo(e.target)){cancelHold();heldFired=false}},true);

  document.addEventListener('click',function(e){
    if(!inLogo(e.target))return;
    if(heldFired){e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();heldFired=false;taps=0;return}
    var now=Date.now();
    taps=(now-lastTap<700)?taps+1:1;lastTap=now;
    clearTimeout(tapTimer);
    if(taps>=2){
      e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
      tapTimer=setTimeout(function(){
        if(taps>1&&taps<5&&!isOn()){var l=logoEl();location.href=(l&&l.getAttribute('href'))||'/'}
        taps=0;
      },800);
    }
    if(taps>=5){clearTimeout(tapTimer);taps=0;toggle()}
  },true);

  window.addEventListener('keydown',function(e){
    var tag=(e.target&&e.target.tagName||'').toLowerCase();
    if(tag==='input'||tag==='textarea'||(e.target&&e.target.isContentEditable))return;
    var k=e.key;if(k&&k.length===1)k=k.toLowerCase();
    if(k===SEQ[idx]){idx++;if(idx===SEQ.length){idx=0;toggle()}}
    else{idx=(k===SEQ[0])?1:0}
  });

  if(persisted()){if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){on(false)})}else{on(false)}}
})();
